import React, { createContext, useContext } from 'react';
import { MenuItem, Tax, Fee } from './types';

interface MenuProviderProps {
  children: React.ReactNode;
  value: {
    taxes: Tax[];
    fees: Fee[];
    showOptions?: boolean;
    menuItems: MenuItem[];
    onMenuItemActionClick?: (menuItem: MenuItem, e: React.MouseEvent) => void;
    onDuplicateClick?: (menuItemId: string) => void;
    onRemoveClick?: (menuItemId: string) => void;
    onMenuItemClick?: (menuItem: MenuItem) => void;
    onReorderMenuItems?: (menuCategoryId: string, menuItemIds: string[]) => void;
    showExpander: boolean;
    numColumns: number;
    headerSize: 'small' | 'large';
    selectedTabColor: 'primary' | 'secondary';
    menuCategoryHeaderGap: number;
  };
}
const initialContext = {} as MenuProviderProps['value'];

export const MenuContext = createContext(initialContext);

export const MenuProvider = ({ children, value }: MenuProviderProps) => (
  <MenuContext.Provider value={value}>{children}</MenuContext.Provider>
);

export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenuContext must be used within a MenuProvider');
  }
  return context;
};
